const api = [{
  name: 'findLoginLog',
  method: 'GET',
  desc: '登录日志',
  path: '/findLoginLog',
  mock: false,
  params: {}
},
{
  name: 'findOperateLog',
  method: 'GET',
  desc: '操作日志',
  path: '/findOperateLog',
  mock: false,
  params: {}
}]

export default {
  BASE_URL: '/sysOperationLog',
  NAMESPACE: 'sysLog',
  api
}



// WEBPACK FOOTER //
// ./src/api/apis/sys/operateLog.js